import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { ADOBE_TAGS, AdobeService, ADOBE_VARIANT_CONSTANTS } from '@sm360/widget-commons-general';
import { CurrencyFormats, ModelYear } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/DrivePowerTrains/drivePowerTrain.scss';
import 'build-and-quote/components/DrivePowerTrains/optionsListing.scss';

/* eslint jsx-a11y/no-static-element-interactions: 0 react/no-danger: 0 */

const DrivePowerTrain = ({
    bestConfiguration,
    drivePowerTrain,
    onDrivePowerTrainClick,
    hasAdobeTagging,
    optionIndex,
}) => {
    useEffect(() => {
        if (hasAdobeTagging && optionIndex === 1) {
            AdobeService.eventTrigger(ADOBE_TAGS.BUILDER_STEPS('performance'), ADOBE_VARIANT_CONSTANTS.GLOBAL_OVERLAY);
        }
    }, []);
    const purchaseMethodAmount = bestConfiguration
        ? bestConfiguration.purchaseMethods.getSelectedPurchaseMethodRetailOrPayment()
        : '';

    const paymentFrequencyLabel = bestConfiguration
        ? bestConfiguration.purchaseMethods.getPaymentFrequencyLabels(false, LocaleService).perPeriod
        : '';

    const drivePowerTrainClasses = ['drive-power-train', 'bloc-options__single'];
    if (drivePowerTrain.selected) {
        drivePowerTrainClasses.push('selected');
    }

    const openPriceClass = !drivePowerTrain.selected ? 'option-price is-price' : 'option-price-selected';
    const optionChooseTextColor = !drivePowerTrain.selected ? 'is-util' : '';
    const optionChooseText = drivePowerTrain.selected ? 'SELECTED' : 'CHOOSE';

    const cityFuel = (
        <span>
            {LocaleService.t('fuel.city')}
            <span className="fuel-bold">{bestConfiguration ? bestConfiguration.fuelCity : 'N/A'}</span>
            {LocaleService.t('fuel.100km')}
        </span>
    );

    const cityHighway = (
        <span className="town">
            {LocaleService.t('fuel.highway')}
            <span className="fuel-bold">{bestConfiguration ? bestConfiguration.fuelHighway : 'N/A'}</span>
            {LocaleService.t('fuel.100km')}
        </span>
    );

    return (
        <div className={drivePowerTrainClasses.join(' ')} role="button" tabIndex={0} onClick={onDrivePowerTrainClick}>
            <div className="bloc-options__single--content">
                <div className="bloc-options__single--body">
                    <ul className="option-list">
                        <li className="option sr-text is-bold">
                            <icon className="icon-Front-Wheel-Drive" />
                            <div>{drivePowerTrain.driveTrain.longDescription}</div>
                        </li>
                        <li className="option sr-text is-bold">
                            <icon className="icon-engine" />
                            <div>
                                <span className="size">
                                    {drivePowerTrain.engine.getSizeSpecifications(LocaleService)}
                                </span>
                                <span className="power">
                                    {drivePowerTrain.engine.getPowerSpecifications(LocaleService)}
                                </span>
                            </div>
                        </li>
                        <li className="option sr-text is-bold">
                            <icon className="icon-transmission" />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: drivePowerTrain.transmission.getTypeAndSpeeds(LocaleService),
                                }}
                            />
                        </li>
                        <li className="option sr-text is-bold consumption">
                            <icon className="icon-fuel" />
                            <div>
                                <span className="cityFuel">{cityFuel}</span>
                                <span className="HighwayFuel">{cityHighway}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div
                    className={
                        drivePowerTrain.selected
                            ? 'bloc-options__single--footer selected'
                            : 'bloc-options__single--footer'
                    }
                >
                    <span className="option-from">{LocaleService.t('startingAt')}</span>

                    <span className={openPriceClass}>
                        {purchaseMethodAmount ? LocaleService.l(purchaseMethodAmount, CurrencyFormats.CURRENCY_0) : ''}
                        <span className="sub">{paymentFrequencyLabel}</span>
                    </span>
                    <button className="option-choose-cta">
                        <icon className="icon-Crochet" />
                        <span className={optionChooseTextColor}>{LocaleService.t(optionChooseText)}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

DrivePowerTrain.propTypes = {
    bestConfiguration: PropTypes.instanceOf(ModelYear.ModelTrimConfigurationModel).isRequired,
    drivePowerTrain: PropTypes.instanceOf(ModelYear.DrivePowerTrainModel).isRequired,
    onDrivePowerTrainClick: PropTypes.func.isRequired,
    hasAdobeTagging: PropTypes.bool.isRequired,
};

DrivePowerTrain.displayName = 'DrivePowerTrain';

export default DrivePowerTrain;
